import { atom } from "jotai";

export const guidanceMessageAtom = atom<string | null>(null);
export const modelsLoadingAtom = atom<boolean>(true);
export const scanStartedAtom = atom<boolean>(false);
type ScanStatus =
  | "correct-posture"
  | "hold-up-arms"
  | "ready-steady-spin"
  | "rotating"
  | "error"
  | "success"
  | "";
export const scanStatusAtom = atom<ScanStatus>("");

export type ScanRotationError = {
  message: string;
  code:
    | "rotation-too-quick"
    | "over-rotation"
    | "under-rotation"
    | "body-out-of-view"
    | "device-moved"
    | "body-not-detected"
    | "insufficient-rotation-data"
    | "unknown"
    | "did-not-rotate-in-place"
    | "upload-failed"
    | "camera-frozen";
};

export const scanRotationErrorAtom = atom<ScanRotationError | null | undefined>(
  null
);

export const allImagesLoadedAtom = atom<boolean>(false);
export const allAudiosLoadedAtom = atom<boolean>(false);

// Asset loading retry states
export const imageLoadingRetryAtom = atom<{
  isRetrying: boolean;
  retryCount: number;
  failedImages: string[];
}>({
  isRetrying: false,
  retryCount: 0,
  failedImages: [],
});

export const audioLoadingRetryAtom = atom<{
  isRetrying: boolean;
  retryCount: number;
  failedAudios: string[];
}>({
  isRetrying: false,
  retryCount: 0,
  failedAudios: [],
});
